export const optimizeScript = () => {
  if (process.env.REACT_APP_ENV === "production") {
    return <script src="https://www.googleoptimize.com/optimize.js?id=OPT-TNHBZJD"></script>;
  } else {
    return <script src="https://www.googleoptimize.com/optimize.js?id=OPT-5B58QW2"></script>;
  }
};
